import { Inbox } from 'lucide-react'
import { dateTime } from '../format'
import { Chip, Empty, Panel } from '../ui'

// ======================================================================
// THE DISCLOSURE REGISTER
// ======================================================================
//
// COVERS BOTH KINDS. Allegation disclosures and evidence disclosures
// both write er_disclosures, so exactly one of evidence_id and
// allegation_id is set on any row, and the register answers "what has
// this person been sent" across both.
//
// `redacted` MEANS THE ITEM SENT WAS ALREADY A REDACTED FORM OF
// SOMETHING. It does NOT mean this system altered the file — the stored
// object is byte-identical to what was uploaded. So the column reads
// "sent as a redacted version", never "redacted by us". See the note on
// the disclosure control in Evidence.jsx.
//
// `first_opened_at` is the receipt, stamped once by the download route
// on the recipient's first read. Its absence means not yet opened, and
// is shown as that rather than as nothing.

export default function Disclosures({ items }) {
  return (
    <Panel eyebrow="What has been sent, to whom" title="Disclosure register">
      {items.length === 0 ? (
        <Empty icon={Inbox} title="Nothing has been disclosed yet">
          Allegations put to the subject and evidence sent to a party are both
          recorded here, with the date they were opened.
        </Empty>
      ) : (
        <ul className="space-y-2">
          {items.map((d) => (
            <li key={d.disclosure_id} className="panel-inset px-4 py-3">
              <div className="flex flex-wrap items-center gap-1.5">
                {d.allegation_ordinal != null ? (
                  <span className="mono text-accent">
                    allegation #{d.allegation_ordinal}
                  </span>
                ) : (
                  <span className="break-all font-head text-[12.5px] font-semibold">
                    {d.original_filename}
                  </span>
                )}
                {d.redacted && <Chip tone="amber">sent as a redacted version</Chip>}
                {d.first_opened_at ? (
                  <Chip tone="blue">opened {dateTime(d.first_opened_at)}</Chip>
                ) : (
                  <Chip>not yet opened</Chip>
                )}
              </div>

              <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-0.5 text-[11.5px] text-faint">
                <span>
                  To <span className="text-muted">{d.recipient_label || d.recipient_id}</span>
                </span>
                {d.sent_by_label && (
                  <span>
                    By <span className="text-muted">{d.sent_by_label}</span>
                  </span>
                )}
                <span>Sent {dateTime(d.sent_at)}</span>
              </div>

              {d.redaction_note && (
                <p className="mt-1.5 text-[12px] leading-relaxed text-muted">
                  <span className="text-faint">What was removed: </span>
                  {d.redaction_note}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </Panel>
  )
}
